import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { OnboardingDialogClose } from '@shared/shared/enums/onboarding-dialog-close';
import * as UserStore from '@shared/store/user';
import { Angulartics2Segment } from 'angulartics2';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ten-continue-popup',
  templateUrl: './continue-popup.component.html',
  styleUrls: ['./continue-popup.component.scss'],
  standalone: true,
  imports: [AsyncPipe, MatLegacyButtonModule, TranslateModule],
})
export class ContinuePopupComponent implements OnDestroy {
  public buttonTypes = OnboardingDialogClose;
  public customVariables$ = this.customVariablesService.variables;
  public user_authenticated$: Observable<boolean> = this.ngrxStore.select(UserStore.getUserAuthenticated);
  private unsubscribe$ = new Subject<void>();
  constructor(
    public dialogRef: MatDialogRef<ContinuePopupComponent>,
    private angulartics2Segment: Angulartics2Segment,
    private customVariablesService: CustomisableVariablesService,
    private ngrxStore: Store<UserStore.UserState>
  ) {
    this.angulartics2Segment.eventTrack('openedOnboardingEndOverlay', Date.now());

    // if the user logs out close the modal
    this.user_authenticated$.pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      if (!res) {
        this.dialogRef.close();
      }
    });
  }

  public closeDialog(type: string) {
    this.angulartics2Segment.eventTrack('onboardingEndOverlayClick', {
      timestamp: Date.now(),
      buttonType: type,
    });
    this.dialogRef.close(type);
  }

  public ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
